import noop from '@picsart/rc/noop';
import { h as AuthFlow, b as AuthActionOptions, e as ComponentsOptions, S as StatusOptions } from './constants-e3c79897.js';

var googleButtonAttributes;
(function (googleButtonAttributes) {
  googleButtonAttributes["type"] = "type";
  googleButtonAttributes["theme"] = "theme";
  googleButtonAttributes["size"] = "size";
  googleButtonAttributes["text"] = "text";
  googleButtonAttributes["shape"] = "shape";
  googleButtonAttributes["logo_alignment"] = "logo_alignment";
  googleButtonAttributes["width"] = "width";
  googleButtonAttributes["locale"] = "locale";
})(googleButtonAttributes || (googleButtonAttributes = {}));
var googleButtonShape;
(function (googleButtonShape) {
  googleButtonShape["rectangular"] = "rectangular";
  googleButtonShape["pill"] = "pill";
  googleButtonShape["circle"] = "circle";
  googleButtonShape["square"] = "square";
})(googleButtonShape || (googleButtonShape = {}));
var googleLogoAlignment;
(function (googleLogoAlignment) {
  googleLogoAlignment["left"] = "left";
  googleLogoAlignment["center"] = "center";
})(googleLogoAlignment || (googleLogoAlignment = {}));
var googleButtonLabelText;
(function (googleButtonLabelText) {
  googleButtonLabelText["signin_with"] = "signin_with";
  googleButtonLabelText["signup_with"] = "signup_with";
  googleButtonLabelText["continue_with"] = "continue_with";
  googleButtonLabelText["signin"] = "signin";
})(googleButtonLabelText || (googleButtonLabelText = {}));
var googleButtonSize;
(function (googleButtonSize) {
  googleButtonSize["large"] = "large";
  googleButtonSize["medium"] = "medium";
  googleButtonSize["small"] = "small";
})(googleButtonSize || (googleButtonSize = {}));
var googleButtonTheme;
(function (googleButtonTheme) {
  googleButtonTheme["outline"] = "outline";
  googleButtonTheme["filled_blue"] = "filled_blue";
  googleButtonTheme["filled_black"] = "filled_black";
})(googleButtonTheme || (googleButtonTheme = {}));
var googleButtonType;
(function (googleButtonType) {
  googleButtonType["icon"] = "icon";
  googleButtonType["standard"] = "standard";
})(googleButtonType || (googleButtonType = {}));
var AuthModalDataForms;
(function (AuthModalDataForms) {
  AuthModalDataForms["insertPasswordForm"] = "insertPasswordForm";
  AuthModalDataForms["createPasswordForm"] = "createPasswordForm";
  AuthModalDataForms["noInternetForm"] = "noInternetForm";
  AuthModalDataForms["modalVisuals"] = "modalVisuals";
  AuthModalDataForms["optionsForm"] = "optionsForm";
  AuthModalDataForms["recentLoginMethodsForm"] = "recentLoginMethodsForm";
  AuthModalDataForms["emailForm"] = "emailForm";
  AuthModalDataForms["welcomeBackEmailCodeAndSSO"] = "welcomeBackEmailCodeAndSSO";
  AuthModalDataForms["welcomeBackMultipleSSO"] = "welcomeBackMultipleSSO";
  AuthModalDataForms["usernameForm"] = "usernameForm";
  AuthModalDataForms["usernameFormSSO"] = "usernameFormSSO";
})(AuthModalDataForms || (AuthModalDataForms = {}));

var _a;
var defaultState = {
  flow: AuthFlow.Default,
  email: '',
  username: '',
  password: '',
  stagedUserInfo: null,
  action: AuthActionOptions === null || AuthActionOptions === void 0 ? void 0 : AuthActionOptions.SignIn,
  currentPage: ComponentsOptions === null || ComponentsOptions === void 0 ? void 0 : ComponentsOptions.OptionsForm,
  pagesHistory: [],
  geoZone: '',
  checkedStates: {},
  socialData: {
    provider: '',
    credential: ''
  },
  status: {
    type: StatusOptions === null || StatusOptions === void 0 ? void 0 : StatusOptions.Default,
    message: ''
  },
  providers: null,
  isIncognito: false,
  setProviders: noop,
  setEmail: noop,
  setUsername: noop,
  setPassword: noop,
  setStatus: noop,
  setAuthAction: noop,
  changeCheckedStates: noop,
  setGeoZone: noop,
  setCurrentPage: noop,
  goPrevPage: noop,
  setCheckedStates: noop,
  setSocialData: noop,
  setStagedUserInfo: noop,
  setIsIncognito: noop
};
var InitialPage = (_a = {}, _a[AuthFlow.Default] = ComponentsOptions.OptionsForm, _a[AuthFlow.RecentLoginMethods] = ComponentsOptions.RecentLoginMethods, _a);

export { AuthModalDataForms as A, InitialPage as I, googleButtonSize as a, googleButtonLabelText as b, googleButtonShape as c, defaultState as d, googleButtonTheme as g };
//# sourceMappingURL=constants-8010f63c.js.map
